import ReactDOM from 'react-dom';


const player = document.getElementById('player-root')
const Player = ({ children }) => ReactDOM.createPortal(children, player)


export default Player
